import React from 'react';
import { CloseButton, Modal } from 'react-bootstrap';

type Props = {
  show: boolean;
  size?: 'sm' | 'lg' | 'xl';
  title?: string;
  children: React.ReactNode;
  handleClose?: () => void;
  onClose?: () => void;
  center?:boolean;
  dialogClassName?: string;
};

const StaticModal = ({
  show,
  title,
  children,
  handleClose,
  onClose,
  size,
  center=false,
  dialogClassName,
}: Props) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop='static'
      keyboard={false}
      size={size}
      centered={center}
      dialogClassName={dialogClassName}
    >
      {title && (
        <Modal.Header>
          <div className='d-flex w-100 justify-content-between align-items-center'>
            <Modal.Title>{title}</Modal.Title>
            <CloseButton onClick={onClose}></CloseButton>
          </div>
        </Modal.Header>
      )}
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default StaticModal;
